(() => {
  if (window.chCollectionLayoutV3) return;
  window.chCollectionLayoutV3 = true;
  const storageKey = 'century-home-recent-products-v1';
  const seenProducts = new WeakSet();
  const recentStates = new WeakMap();
  const seenPrices = new WeakSet();
  const getStored = () => {
    try {
      const rows = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(rows) ? rows.slice(0, 12) : [];
    } catch (_) { return []; }
  };
  function safeProductUrl(value) {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return null;
      url.search = '';
      url.hash = '';
      return url;
    } catch (_) { return null; }
  }
  function trackProduct() {
    document.querySelectorAll('[data-ch-recent-product]').forEach(marker => {
      if (seenProducts.has(marker)) return;
      seenProducts.add(marker);
      const url = safeProductUrl(marker.dataset.productUrl);
      const id = marker.dataset.productId;
      if (!url || !id) return;
      const record = { id, url: url.pathname, variant: marker.dataset.variantId || '' };
      const remaining = getStored().filter(row => row && String(row.id) !== id);
      try { localStorage.setItem(storageKey, JSON.stringify([record, ...remaining].slice(0, 12))); } catch (_) {}
    });
  }
  async function fetchProduct(row) {
    const url = safeProductUrl(row.url);
    if (!url) return null;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 7000);
    try {
      const response = await fetch(url.pathname.replace(/\/$/, '') + '.js', { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return null;
      const product = await response.json();
      if (!product || !product.id || String(product.id) !== String(row.id) || !product.title || !Array.isArray(product.variants)) return null;
      const variant = product.variants.find(item => String(item.id) === String(row.variant)) || product.variants.find(item => item.available) || product.variants[0];
      if (!variant || !Number.isFinite(Number(variant.price))) return null;
      return { product, variant, url };
    } catch (_) { return null; }
    finally { clearTimeout(timeout); }
  }
  async function renderRecent(widget) {
    const list = widget.querySelector('[data-ch-recent-list]');
    if (!list) return;
    const empty = widget.querySelector('[data-ch-recent-empty]');
    const rows = getStored().filter(row => row && row.url && row.id).slice(0, 3);
    const signature = [widget.dataset.currency || 'HNL', widget.dataset.locale || 'es-HN', ...rows.map(row => String(row.id) + ':' + String(row.variant || '') + ':' + row.url)].join('|');
    const state = recentStates.get(widget);
    if (!rows.length) {
      recentStates.delete(widget);
      if (list.childElementCount) list.replaceChildren();
      widget.hidden = !empty;
      if (empty) empty.hidden = false;
      return;
    }
    const sameHistory = state?.signature === signature;
    if (sameHistory && state.loading) return;
    if (sameHistory && list.childElementCount) { widget.hidden = false; if (empty) empty.hidden = true; return; }
    let products = sameHistory ? state.products : null;
    if (!products) {
      const pending = { loading: true, signature };
      recentStates.set(widget, pending);
      products = await Promise.all(rows.map(fetchProduct));
      if (recentStates.get(widget) !== pending) return;
      recentStates.set(widget, { loading: false, signature, products });
    }
    if (!widget.isConnected) return;
    const fragment = document.createDocumentFragment();
    for (const result of products) {
      if (!result) continue;
      const { product, variant, url } = result;
      const link = document.createElement('a');
      link.className = 'ch-col-recent-row';
      link.href = url.pathname + '?variant=' + encodeURIComponent(variant.id);
      if (product.featured_image) {
        try {
          const imageUrl = new URL(product.featured_image, location.origin);
          if (imageUrl.protocol === 'https:') {
            const image = document.createElement('img');
            image.src = imageUrl.href;
            image.alt = product.title;
            image.loading = 'lazy';
            image.width = 42;
            image.height = 42;
            link.append(image);
          }
        } catch (_) {}
      }
      const title = document.createElement('span');
      title.className = 'ch-col-recent-row__title';
      title.textContent = product.title;
      const price = document.createElement('span');
      price.className = 'ch-col-recent-row__price';
      try {
        price.textContent = new Intl.NumberFormat(widget.dataset.locale === 'es' ? 'es-HN' : widget.dataset.locale || 'es-HN', { style: 'currency', currency: widget.dataset.currency || 'HNL', currencyDisplay: 'narrowSymbol' }).format(Number(variant.price) / 100);
      } catch (_) { price.textContent = (Number(variant.price) / 100).toFixed(2); }
      link.append(title, price);
      fragment.append(link);
    }
    if (fragment.childElementCount) {
      list.replaceChildren(fragment);
      widget.hidden = false;
      if (empty) empty.hidden = true;
    } else {
      if (list.childElementCount) list.replaceChildren();
      widget.hidden = !empty;
      if (empty) empty.hidden = false;
    }
  }
  function preparePrice(form) {
    const min = form.querySelector('[data-ch-price-min]');
    const max = form.querySelector('[data-ch-price-max]');
    const rangeMin = form.querySelector('[data-ch-range-min]');
    const rangeMax = form.querySelector('[data-ch-range-max]');
    if (!min || !max || !rangeMin || !rangeMax) return;
    const sync = source => {
      const ceiling = Number(rangeMax.max);
      let from = Math.max(0, Math.min(ceiling, Number(source === rangeMin ? rangeMin.value : min.value) || 0));
      let to = Math.max(0, Math.min(ceiling, Number(source === rangeMax ? rangeMax.value : max.value) || 0));
      if (from > to) {
        if (source === min || source === rangeMin) from = to;
        else to = from;
      }
      min.value = String(Math.round(from * 100) / 100);
      max.value = String(Math.round(to * 100) / 100);
      rangeMin.value = min.value;
      rangeMax.value = max.value;
    };
    [rangeMin, rangeMax].forEach(input => input.addEventListener('input', () => sync(input)));
    // Let customers finish typing before normalizing the numeric fields.
    [min, max].forEach(input => input.addEventListener('change', () => {
      sync(input);
      rangeMin.dispatchEvent(new Event('input', { bubbles: true }));
    }));
    form.addEventListener('submit', () => sync(min));
  }
  function preserveAppliedFilters(event) {
    if (!(event.target instanceof Element)) return;
    const form = event.target.closest('.ch-col-main facets-form-component form');
    if (!form) return;
    form.querySelectorAll('[data-ch-preserved-filter]').forEach(input => input.remove());
    const existingNames = new Set(Array.from(form.elements).map(input => input.name));
    for (const [name, value] of new URL(location.href).searchParams) {
      if (!name.startsWith('filter.') || existingNames.has(name)) continue;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      input.dataset.chPreservedFilter = 'true';
      form.append(input);
    }
  }
  function refresh() {
    trackProduct();
    document.querySelectorAll('[data-ch-price]').forEach(form => {
      if (seenPrices.has(form)) return;
      seenPrices.add(form);
      preparePrice(form);
    });
    document.querySelectorAll('[data-ch-recent]').forEach(widget => renderRecent(widget));
  }
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; refresh(); });
  };
  function start() {
    document.addEventListener('change', preserveAppliedFilters, true);
    refresh();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('pageshow', event => {
      if (event.persisted) {
        document.querySelectorAll('[data-ch-recent-product]').forEach(marker => seenProducts.delete(marker));
      }
      schedule();
    });
    window.addEventListener('storage', event => {
      if (event.key !== storageKey) return;
      document.querySelectorAll('[data-ch-recent]').forEach(widget => {
        recentStates.delete(widget);
        widget.querySelector('[data-ch-recent-list]')?.replaceChildren();
        widget.hidden = true;
      });
      schedule();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

